import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authActions } from "../../store/store";
import { Container, Grid } from "@mui/material";
import Hazard from "../../../src/assets/common-images/images/hazard.png";

export const RestrictUser = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(authActions.logout());
  }, []);
  const navigateToLogin = () => {
    navigate("/authentication/signin");
  };
  return (
    <Container
      sx={{
        height: "100vh",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        spacing={5}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Grid item md={4} xs={12}>
          <img src={Hazard} alt="hazard" width="100%" height="100%" />
        </Grid>
        <Grid item lg={5} xs={12}>
          <p
            className="error-color fw-700"
            style={{ fontSize: "60px", margin: "0px" }}
          >
            Warning
          </p>
          <p
            className="grey-color fw-700"
            style={{ fontSize: "48px", marginTop: "10px" }}
          >
            Stop right there!
          </p>
          <p>
            You are accessing incorrect path, In this case of Penalty your
            acccount can be blocked.
          </p>
          <button className="btn-primary" onClick={() => navigateToLogin()}>
            Back to Home
          </button>
        </Grid>
      </Grid>
    </Container>
  );
};
